import { Controller } from "@hotwired/stimulus";
import posthog from "posthog-js";

export default class extends Controller {
  static targets = ["price", "select"];
  static outlets = ["modal"];
  static values = { prices: Object };

  update() {
    const price = this.pricesValue[this.selectTarget.value];
    if (price) {
      this.priceTarget.textContent = price;
    }
  }

  subscribe() {
    posthog.capture("pricing_subscribe_clicked", { plan_level: this.selectTarget.value });
    if (this.hasModalOutlet) {
      this.modalOutlet.open();
      this.modalOutlet.element.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
}
